import { render, staticRenderFns } from "./MonthlyReview.vue?vue&type=template&id=36df0c3c"
import script from "./MonthlyReview.vue?vue&type=script&lang=js"
export * from "./MonthlyReview.vue?vue&type=script&lang=js"
import style0 from "./MonthlyReview.vue?vue&type=style&index=0&id=36df0c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports